import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext'; // Adjust the import path as needed

export default function Protected(props) {
    const { Component } = props;
    const navigate = useNavigate();
    const { auth } = useAuth();
    // console.log("auth===>",auth)

    useEffect(() => {
        if (!auth.isAuthenticated) {
            navigate('/');
        }
    }, [auth.isAuthenticated, navigate]);

    return (
        <div>
            {auth.isAuthenticated && <Component />}
        </div>
    );
}
